// extracted by mini-css-extract-plugin
export default {"info":"ProductsInfo_info__DZTUw","titleWrapper":"ProductsInfo_titleWrapper__7WGSD","title":"ProductsInfo_title__DxMm6","cardList":"ProductsInfo_cardList__iH6Ov"};